import React from "react";
import Select from "react-select";
import { useImmer } from "use-immer";

const SelectCustom = (props) => {
  const { icon, paddingRight, paddingLeft, width, isDisabled, ...rest } = props;
  const [menuIsOpen, setMenuIsOpen] = useImmer(false);

  return (
    <div className="relative w-full">
      {icon && (
        <img
          className="absolute z-10 flex my-2 mr-2"
          src={icon}
          width={16}
          alt="icon"
        />
      )}
      <Select
        {...rest}
        isDisabled={isDisabled}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        placeholder={props.placeholder}
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : null
        }
        menuPosition="fixed"
        onKeyDown={(event) => {
          if (menuIsOpen) event.stopPropagation();
        }}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 999999, // 🔥 بدون این منو پشت Dialog می‌مونه
          }),
          control: (provided, state) => ({
            ...provided,
            minWidth: "125px",
            minHeight: "40px",
            padding: "0px 8px",
            borderRadius: "8px",
            backgroundColor: "#1f1f1f",
            paddingRight: icon ? "24px" : paddingRight ? paddingRight : "8px",
            paddingLeft: paddingLeft,
            color: "#fff",
            fontSize: "1rem",
            borderColor: state.isFocused ? " #8d8d8d" : "#555960",
            borderWidth: "1px",
            borderStyle: "solid",
            width: width || "100%",
            alignItems: "center",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#1f1f1f",
            },
          }),
          valueContainer: (provided) => ({
            ...provided,
            padding: "0px 4px",
          }),
          option: (provided, { isFocused }) => ({
            ...provided,
            backgroundColor: isFocused
              ? "rgba(134, 160, 255, 0.82)"
              : "#1f1f1f",
            color: "#fff",
            padding: "8px",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }),
          menuList: (provided) => ({
            ...provided,
            borderRadius: "6px",
            marginTop: "8px",
            padding: "8px 0px",
            backgroundColor: "#1f1f1f",
            boxShadow: "5px 7px 9px -4px #0000008f",
          }),
          input: (provided) => ({
            ...provided,
            margin: "-4px",
            padding: "0px",
          }),
        }}
      />
    </div>
  );
};

export { SelectCustom };
